// Recursively import all markdown files
function importAll(r) {
    const files = {};

    r.keys().forEach((key) => {
        const cleanKey = key.replace("./", ""); // e.g., "privacy_policy/privacy_policy_en.md"
        const filename = cleanKey.split("/").pop(); // "privacy_policy_en.md"

        const match = filename.match(/([^_]+)_([^.]+)\.md$/);
        if (match) {
            const normalizedKey = `${match[1]}_${match[2]}`; // "privacy_policy_en"
            files[normalizedKey] = r(key).default || r(key);
        }
    });

    return files;
}

// Import all .md files from /documents folder and subfolders
const markdowns = importAll(require.context("../documents", true, /\.md$/));

/**
 * Get markdown content (or URL depending on loader)
 * @param {string} key - normalized key, e.g. "privacy_policy_en"
 */
export function getMarkdownFile(key) {
    return markdowns[key];
}
